// Sound effects using Web Audio API — no external files needed
const AudioCtx = window.AudioContext || window.webkitAudioContext;
let ctx;
function getCtx() { if (!ctx) ctx = new AudioCtx(); return ctx; }

function playTone(freq, duration, type = "sine", vol = 0.3) {
  try {
    const c = getCtx();
    const osc = c.createOscillator();
    const gain = c.createGain();
    osc.type = type;
    osc.frequency.value = freq;
    gain.gain.value = vol;
    gain.gain.exponentialRampToValueAtTime(0.01, c.currentTime + duration);
    osc.connect(gain);
    gain.connect(c.destination);
    osc.start();
    osc.stop(c.currentTime + duration);
  } catch {}
}

export function playCorrect() {
  playTone(523, 0.1); // C5
  setTimeout(() => playTone(659, 0.1), 100); // E5
  setTimeout(() => playTone(784, 0.15), 200); // G5
}

export function playWrong() {
  playTone(200, 0.15, "sawtooth", 0.2);
  setTimeout(() => playTone(180, 0.2, "sawtooth", 0.15), 150);
}

export function playLevelUp() {
  [523, 587, 659, 784, 880, 1047].forEach((f, i) => {
    setTimeout(() => playTone(f, 0.12, "sine", 0.25), i * 80);
  });
}

export function playXP() {
  playTone(880, 0.08);
  setTimeout(() => playTone(1100, 0.1), 80);
}

export function playClick() {
  playTone(600, 0.05, "sine", 0.1);
}
